import { render, staticRenderFns } from "./Report2.vue?vue&type=template&id=5f4c4286&"
import script from "./Report2.vue?vue&type=script&lang=js&"
export * from "./Report2.vue?vue&type=script&lang=js&"
import style0 from "./Report2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Report2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports